import React, { useState, useEffect } from "react";
import {
  updateFormField,
  updateQuestionState,
} from "../../../store/slices/path.slice";

import AllQuestionsView from "./AllQuestionsView";
import QuestionWrapper from "./QuestionWrapper"; // For normal steps

/**
 * This is the final "Review All" step as a REAL React component.
 * We define it outside the config so we can use hooks safely.
 */
function AllQuestionsReviewStep({
  state,
  setState,
  handleFinish,
  currentStep,
  setCurrentStep,
  dispatch,
  pathQuestions,
}) {
  // Locally track updated answers so we don't trigger Redux on each change
  const [tempAnswers, setTempAnswers] = useState(state);

  // Local callback for question changes
  const handleLocalQuestionChange = (qId, newVal) => {
    setTempAnswers((prev) => ({ ...prev, [qId]: newVal }));
  };

  // "Save all" merges local changes to Redux + main state
  const handleSaveAll = () => {
    Object.entries(tempAnswers).forEach(([qId, value]) => {
      dispatch(updateFormField({ field: qId, value }));
      dispatch(
        updateQuestionState({
          questionId: qId,
          completed: true,
          hasComponent: true,
          value,
        })
      );
    });
    // Also update the main step-based state
    setState(tempAnswers);
    // If you want to immediately finish (or move next)
    handleFinish();
    // or: setCurrentStep(currentStep + 1);
  };

  return (

      <AllQuestionsView
        pathQuestions={pathQuestions}
        state={tempAnswers}
        handleQuestionChange={handleLocalQuestionChange}
        // If you want the button inside AllQuestionsView, pass onSaveAll:
        onSaveAll={handleSaveAll}
      />
  );
}

export default AllQuestionsReviewStep;
